













import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Rank extends Vue {
  @Prop() voteType!: [];
  red: string = 'rgb(255,242,206)';
}
